import React from 'react';
import { Path, RegisterOptions, UseFormRegister } from 'react-hook-form';
import "./Input.css";

interface FormInputProps<K> extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>{
    label: string;
    register: UseFormRegister<K>;
    registerId: Path<K>;
    options?: RegisterOptions<K, Path<K>>;
}

const FormInput = <K extends {}>({label, register, registerId, options, ...props}: FormInputProps<K>) => {
    return (
        <div className="inputContainer">
            <label
                className={`inputlabel ${props.required ? "required" : ""}`}
            >
                {label}
            </label>
            <input 
                className='form-control'
                {...register(registerId, {required: props.required, ...options})}
                {...props}
            />
        </div>
    )
};

export default FormInput;
